import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { FieldArray, useField } from 'formik';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import InputField from '../../../components/fields/InputField';
import TextAreaField from '../../../components/fields/TextAreaField';

type PathScriptFieldProps = {
    name: string;
};

const StyledButton = styled(Button)`
    padding-left: 0;
    padding-right: 0;
`;

const GroupedLabel = styled.div`
    display: flex;
    width: 100%;
`;

const DeleteButton = styled(Button)`
    margin-left: auto;
`;

const PathScriptField = ({ name }: PathScriptFieldProps) => {
    const { t } = useTranslation(['routerDetails']);
    const [field, meta] = useField({ name });
    const { value } = meta;

    return (
        <FieldArray
            {...field}
            name={name}
            render={arrayHelpers => (
                <>
                    {value?.map((_: string, index: number) => (
                        <>
                            <InputField
                                {...t('routerDetails:endpoints.fields.scriptPathName', {
                                    returnObjects: true,
                                    index: value.length > 1 ? index + 1 : null,
                                })}
                                label={
                                    <GroupedLabel>
                                        {t('routerDetails:endpoints.fields.scriptPathName.label', {
                                            index: value.length > 1 ? index + 1 : null,
                                        })}
                                        <DeleteButton
                                            icon={<DeleteOutlined />}
                                            onClick={() => arrayHelpers.remove(index)}
                                            size="small"
                                            type="link"
                                            danger
                                        />
                                    </GroupedLabel>
                                }
                                name={`${name}.${index}.pathname`}
                            />
                            <TextAreaField
                                name={`${name}.${index}.script`}
                                placeholder={t('routerDetails:endpoints.fields.script.placeholder')}
                            />
                        </>
                    ))}
                    <StyledButton
                        icon={<PlusOutlined />}
                        onClick={() => {
                            arrayHelpers.push({});
                        }}
                        type="link"
                    >
                        {t('routerDetails:endpoints.buttons.addScript')}
                    </StyledButton>
                </>
            )}
        />
    );
};

export default PathScriptField;
